const EventIdRadixNumber = 36
const EventIdSlice = 2

class PixelUtils {
  static formatEventId() {
    return `${new Date().getTime()}-${Math.random()
      .toString(EventIdRadixNumber)
      .slice(EventIdSlice)}`
  }
}

export default PixelUtils
